export default "__VITE_ASSET__BYKQs6dv__"